import { defineStore } from 'pinia';

export const useCurrencyStore = defineStore({
    id: "useCurrencyStore",
    state: () => ({
        rootUrl: '/api/Participation/',
        currency: ''
    }),
    actions: {
        async getDefaultCurrency() {
            const response = await this.axiosFactory
                .withoutToken()
                .get(`${this.$state.rootUrl}GetDefaultCurrencySymbol`);

            if (response.data) {
                this.currency = response.data.data;
            }
        }
    }
})